import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getAppliedParamsValues } from '~/components/Filters/FiltersBar/filtersBarUtils';
import { FilterTrigger } from '~/components/Filters/SingleFilters/FilterTrigger';
import { SingleTagFilter } from '~/components/Filters/TagsFilter/SingleTagFilter';
import { type SingleFilterProps } from '~/components/Filters/types';
import { baseFiltersOptions } from '~/components/FiltersMenu/types';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type TagFilterTriggerProps = SingleFilterProps;

export const TagFilterTrigger = memo(({ onApplyClick, onRemoveClick, onOpenChange }: TagFilterTriggerProps) => {
  const dispatch = useDispatch();
  const { tagsParam } = useFilterParams();

  const content = useMemo(() => <SingleTagFilter onApplyClick={onApplyClick} />, [onApplyClick]);

  const appliedTagsValues = useMemo(() => getAppliedParamsValues(tagsParam), [tagsParam]);

  const removeFilter = useCallback(async () => {
    const filter: SelectedFilter = { type: 'tags' };
    dispatch(removeFilterAction({ filter }));
    onRemoveClick?.([filter]);
  }, [dispatch, onRemoveClick]);

  return (
    <FilterTrigger
      filterContent={content}
      title={baseFiltersOptions['tags'].label}
      values={appliedTagsValues}
      onRemoveClick={removeFilter}
      Icon={baseFiltersOptions['tags'].icon}
      onOpenChange={onOpenChange}
    />
  );
});

TagFilterTrigger.displayName = 'TagFilterTrigger';
